"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const removeFieldMappingTag = (value) => lodash_1.get(value.match(/\{\{[0-9]*__(.*)\}\}/), [1], value);
exports.default = removeFieldMappingTag;
